import { IconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import { withStyles, WithStyles } from "@mui/styles";
import { GlobalClassKeys } from "assets/jss/common-styles";
import colorsStyle from "assets/jss/mui-extras/colorsStyle";
import classNames from "classnames";
import { MuiColors } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";


interface IProps {
    color?: MuiColors;
    visible?: boolean;
    pressed?: boolean;
}

export type MuiIconButtonProps = IProps & Omit<IconButtonProps, "classes" | "color">;

type Props = MuiIconButtonProps & WithStyles<typeof colorsStyle>;

class MuiIconButton extends React.PureComponent<Props>  {

    render() {
        const { className, classes, color, children, visible, ...rest } = this.props;

        return (
            <IconButton
                {...rest}
                className={
                    classNames(
                        className,
                        {
                            [GlobalClassKeys.hideElement]: visible === false,
                            [classes[color]]: color,
                            [className]: className !== undefined
                        }
                    )
                }
            >
                {children}
            </IconButton >
        );
    }
}

export default withStyles(colorsStyle)(MuiIconButton);
